import React from 'react';

import Modal from '../../components/UI/Modal';
import DetailsContent from './DetailsContent';

const RenderDetailsModal = ({
    item,
    loading,
    selectedItemId,
    showDetailsModal,
    handleClose,
}) => {
    const waitingForSelected = loading && (
        !item?._id ||
        String(item._id) !== String(selectedItemId)
    );

    return (
        <Modal
            show={showDetailsModal}
            handleClose={handleClose}
            modalTitle="История изменения профиля"
            size="lg"
            disabledFunctional
            closeText="Закрыть"
        >
            <div className="applicationChangeProfile__modal">
                {waitingForSelected ? (
                    <div className="applicationChangeProfile__modalLoading">
                        <div className="applicationChangeProfile__loaderDot" />
                        <span>Загружаем запись…</span>
                    </div>
                ) : item?._id ? (
                    <DetailsContent item={item} />
                ) : (
                    <div className="applicationChangeProfile__modalLoading">
                        Не удалось загрузить запись
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default RenderDetailsModal;
